import { RuleActionType } from '@jupiterone/jupiter-types';
import {
  IntegrationInstanceSelector,
  JSONInput,
  JupiterTheme,
} from '@jupiterone/jupiter-web-toolkit';
import {
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
} from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React, { ChangeEvent, useEffect, useState } from 'react';
import HelpIcon from 'react-feather/dist/icons/help-circle';
import { RuleActionData, SNSActionData } from 'jupiter-web-alerts/src/types';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    full: {
      display: 'block',
      marginBottom: theme.spacing(1),
    },
  })
);

interface Props {
  onUpdate: (newValue: RuleActionData) => void;
  disabled?: boolean;
  initialActionData?: SNSActionData;
}

const DEFAULT_ACTION_DATA = {
  type: RuleActionType.PUBLISH_SNS_MESSAGE,
  topicArn: 'arn:aws:sns:<REGION>:arn:aws:sns:<ACCOUNT_ID>:<SNS_TOPIC_NAME>',
  data: {
    query0Data: '{{queries.query0.data}}',
  },
  integrationInstanceId: '',
};

const textFields = [
  {
    name: 'topicArn',
    label: 'Topic Arn',
    helpText: 'The arn of the sns topic that should be published to',
  },
];

const SNSRuleConfig = ({
  onUpdate,
  disabled,
  initialActionData = DEFAULT_ACTION_DATA,
}: Props) => {
  const [internalActionState, setInternalActionState] = useState<SNSActionData>(
    initialActionData
  );

  const classes = useStyles();

  useEffect(() => {
    const { topicArn, integrationInstanceId, data } = internalActionState;
    const action: SNSActionData = {
      ...initialActionData,
      type: RuleActionType.PUBLISH_SNS_MESSAGE,
      integrationInstanceId,
      topicArn,
      data,
    };
    onUpdate(action);
  }, [internalActionState]);

  const handleChangeValue = (e: ChangeEvent<HTMLInputElement>) =>
    setInternalActionState({
      ...internalActionState,
      [e.target.name]: e.target.value,
    });

  return (
    <div>
      {textFields.map(({ name, label, helpText }) => (
        <TextField
          key={name}
          className={classes.full}
          fullWidth={true}
          onChange={handleChangeValue}
          name={name}
          value={internalActionState[name]}
          label={label}
          inputProps={{
            'aria-label': label,
          }}
          disabled={disabled}
          InputProps={{
            endAdornment: helpText && (
              <InputAdornment position="end">
                <Tooltip title={helpText}>
                  <IconButton>
                    <HelpIcon size={20} />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />
      ))}

      <IntegrationInstanceSelector
        disabled={disabled}
        value={internalActionState.integrationInstanceId}
        integrationFilter="AWS"
        onSelect={(id: string) =>
          handleChangeValue({
            target: { name: 'integrationInstanceId', value: id },
          } as any)
        }
      />

      <JSONInput
        value={internalActionState.data ? internalActionState.data : {}}
        onChange={handleChangeValue}
        label={'Data'}
        disabled={disabled}
        name={'data'}
      />
    </div>
  );
};

export default SNSRuleConfig;
